<template>
  <div class="payTest">
    <h2 class="block__title">Nicepay Test</h2>
    <van-form ref="form" method="post" action="">
      <van-cell-group>
        <van-field name="radio" label="PayMethod">
          <template #input>
            <van-radio-group v-model="form.PayMethod" direction="horizontal">
              <van-radio style="margin-bottom: 10px" name="CARD">Credit Card</van-radio>
              <van-radio style="margin-bottom: 10px" name="BANK">Bank Transfer</van-radio>
              <van-radio style="margin-bottom: 10px" name="VBANK">Virtual Account</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-model="form.Price" name="AMT" label="AMT" placeholder="Price"/>
        <van-field v-model="form.BuyerName" name="BuyerName" label="BuyerName"
                   placeholder="BuyerName"/>
        <van-field v-model="form.BuyerEmail" name="BuyerEmail" label="BuyerEmail"
                   placeholder="BuyerEmail"/>
        <van-field v-model="form.BuyerTel" name="BuyerTel" label="BuyerTel" placeholder="BuyerTel"/>
      </van-cell-group>
      <van-button type="primary" block native-type="submit" @click="handlePay">Submit</van-button>
    </van-form>
    <script type="application/javascript" defer
            src="https://web.nicepay.co.kr/v3/webstd/js/nicepay-3.0.js"></script>
  </div>
</template>

<script type="text/javascript">
import sha256 from 'js-sha256';

var merchantID = 'nicepay00m';
var merchantKey = 'EYzu8jGGMfqaDEp76gSckuvnaHHu+bC4opsSN6lHv3b2lurNYkVXrZ7Z1AoqQnXI3eLuaUFyoRNC6FkrzVjceg==';
var paymentUrl = 'https://web.nicepay.co.kr/v3/v3Payment.jsp';

function correct(n) {
  return n > 9 ? n : '0' + n;
}

function getDate(time) {
  let date = new Date(time);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let d = date.getDate();
  let hour = date.getHours();
  let minute = date.getMinutes();
  return '' + year + month + correct(d) + +correct(hour) + correct(minute);
}

export default {
  name: 'payTest',
  props: {},
  mixins: [],
  components: {},
  data() {
    return {
      form: {
        PayMethod: 'CARD',
        Price: '104',
        BuyerName: 'blueshark',
        BuyerEmail: 'nicepay@blueshark.com',
        BuyerTel: '',
      },
    };
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    handlePay() {
      let date = getDate(Date.now());
      let hash = sha256.sha256(date + merchantID + this.form.Price + merchantKey);
      console.log(hash);
      let req = {
        'PayMethod': this.form.PayMethod,
        'GoodsName': 'Nicepay Test Goods',
        'Amt': this.form.Price,
        'MID': merchantID,
        'Moid': 'bsoid2021052515213' ,
        'BuyerName': this.form.BuyerName,
        'BuyerEmail': this.form.BuyerEmail,
        'BuyerTel': this.form.BuyerTel,
        'ReturnURL': CABAPI_URL + '/battswap/app/order/webhook/nicepay',
        'NpLang': 'EN',
        'GoodsCl': '1',
        'TransType': '0',
        'CharSet': 'utf-8',
        'ReqReserved': '',
        'EdiDate': date,
        'SignData': hash,
        'VbankExpDate': '',
      };
      let form = this.$refs.form.$el;
      for (let reqKey in req) {
        this.setFormData(form, reqKey, req[reqKey]);
      }
      form.acceptCharset = 'euc-kr';
      form.action = paymentUrl;
      form.submit();
    },
    setFormData(f, key, value) {
      if (f[key]) {
        f[key].value = value;
      } else {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        f.appendChild(input);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.payTest {
  max-width: 640px;
  margin: 0 auto;
  padding: 20px 10px;
}

.block__title {
  padding: 32px 16px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/battswap/payTest.vue